import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, Inject } from '@angular/core';
// import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import * as _ from 'lodash';
import { RootService } from '../../../service/root.service';
// import { stringify } from 'querystring';

@Component({
    selector: 'panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss']
})
export class PanelComponent implements OnInit {
    @Input() table;
    @Input() collapse = false;
    operation  = 'read';
    @Output() removeHandler = new EventEmitter();
    @Output() duplicateHandler = new EventEmitter();
    langBtn = 'en';
    page = 'mvc';
    showPopover($event, popover) {

        popover.show($event);
    }
    removeOption() {
        this.removeHandler.emit('remove it');
    }
    duplicateOption(table) {
        // let newTable = Object.assign({}, table);
        let newTable = _.cloneDeep(table);

        this.duplicateHandler.emit(newTable);
    }
    copyClipboard(table) {
        console.log(table);
        const temp = _.cloneDeep(table);
        const temp2 = JSON.stringify(temp);
        document.addEventListener('copy', (e: ClipboardEvent) => {
            e.preventDefault();
            e.clipboardData.setData('text', temp2);
            document.removeEventListener('copy', null);
          });
          document.execCommand('copy');
          this.rootService.toast.showSuccess('Copied to Clipboard','Table');
    }


    constructor(public rootService: RootService) { }
    setTableName(tableName) {
        let name = '';
        if (tableName.length > 0) {
            name = tableName.charAt(0).toLowerCase() + tableName.slice(1);
            // replacing space with _
            var re = /\s/;
            name = name.replace(re, "_");

            var re = /\s/;
            name = name.replace(/[&\/\\#,+()$~%.'":*?<>{}@!^]/g, "");
        }
        this.table.name = name;
    }
    ngOnInit() {


    }
    addLangValue(v, lang) {

        if (lang.header.one) {
            lang.create.title += lang.header.one;
            lang.read.title += lang.header.one;
            lang.update.title += lang.header.one;
            lang.clone.title += lang.header.one;
            // lang.header.title += lang.header.title;
        }
        if (lang.header.title) {
            if (this.langBtn === 'en') {
                lang.list.title = lang.header.title + ' ' + lang.list.title;
            } else {

                lang.list.title += lang.header.title;
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/module/project/panel/panel.component.ts